import React from "react";
import { Progress } from "../ui/progress";
import { Checkbox } from "components/ui/checkbox";

const EquipmentChecklist = ({ hasItems = [], needsItems = [], selectedIds = [] }) => {
  // 1. Identify all unique items using a Map keyed by equipment_id.
  const uniqueEquipmentMap = new Map();

  const checkedStatusIds = new Set();

  hasItems.forEach(item => {
    if (item && item.equipment_id) {
      checkedStatusIds.add(item.equipment_id);
    }
  });

  selectedIds.forEach(id => {
      checkedStatusIds.add(id);
  });

  needsItems.forEach(item => {
    if (item && item.equipment_id) {
      uniqueEquipmentMap.set(item.equipment_id, item);
    }
  });

  hasItems.forEach(item => {
     if (item && item.equipment_id && !uniqueEquipmentMap.has(item.equipment_id)) {
        uniqueEquipmentMap.set(item.equipment_id, item);
    }
  });

  const finalEquipmentList = Array.from(uniqueEquipmentMap.values());

  const totalItems = finalEquipmentList.length;
  const itemsChecked = finalEquipmentList.filter(item => checkedStatusIds.has(item.equipment_id)).length;

  const progressValue = totalItems > 0 ? (itemsChecked / totalItems) * 100 : 0;
  const progressClassName = "w-full h-2 rounded-full bg-white [&>div]:bg-accent [&>div]:rounded-full";

  return (
    <div className="border border-border bg-card rounded-2xl p-6 w-full flex flex-col gap-6">
      <div>
        <p className="mb-2 text-base font-bold text-foreground">Equipment Required</p>
        <p className="text-muted-foreground text-xs font-normal">Our AI will analyze your requirements and automatically match you with the best crew members and equipment from our marketplace.</p>
      </div>
      <div className="flex flex-col gap-4">
        <Progress value={progressValue} className={progressClassName} />
        <div className="text-xs font-bold flex justify-between text-foreground">
          <span>Equipment Checklist</span>
          <span>{String(itemsChecked).padStart(2, '0')}/{String(totalItems).padStart(2, '0')}</span>
        </div>
        <div className="flex flex-col gap-2">
          {finalEquipmentList.map((item, index) => {
            const isChecked = checkedStatusIds.has(item.equipment_id);
            return (
              <div key={item.equipment_id || index} className="flex items-center gap-2 text-sm text-foreground font-medium">
                <Checkbox
                  id={`equipment-${item.equipment_id || index}`}
                  checked={isChecked}
                  disabled
                  className="bg-background border-border data-[state=checked]:border-accent data-[state=checked]:bg-accent data-[state=checked]:text-primary-foreground disabled:opacity-100"
                />
                <label htmlFor={`equipment-${item.equipment_id || index}`} className="cursor-default">
                  {item.equipment_name}
                </label>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EquipmentChecklist;
